// navigateToChat.js
export const createNavigateToChat = ({kbSubdomain, setChatId, navigate}) => {
    return (chatId, e) => {
        const isNewTab = e && (e.ctrlKey || e.metaKey);
        if (kbSubdomain) {
            if (chatId === null) {
                const to = '/'
                if (isNewTab) {
                    window.open(to, '_blank')
                } else {
                    setChatId(false)
                    navigate(to);
                }
            } else {
                const to = `/chat/${encodeURIComponent(chatId)}`
                if (isNewTab) {
                    window.open(to, '_blank')
                } else {
                    setChatId(chatId)
                    navigate(to)
                }
            }
        }
    };
};